import { useEffect } from "react";
import { GTM_ID } from "../../constants";

export const useLazyGTM = () => {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    const loadGTM = () => {
      if (window.gtmLoaded) return;
      window.gtmLoaded = true;

      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
      document.head.appendChild(script);

      // Add noscript iframe for fallback
      const noscript = document.createElement("noscript");
      const iframe = document.createElement("iframe");
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
      iframe.height = "0";
      iframe.width = "0";
      iframe.style.display = "none";
      iframe.style.visibility = "hidden";
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);
    };

    const timer = setTimeout(loadGTM, 2000);

    const events = ["scroll", "mousemove", "touchstart", "click"];
    const onInteraction = () => {
      loadGTM();
      events.forEach((event) =>
        window.removeEventListener(event, onInteraction)
      );
    };
    events.forEach((event) =>
      window.addEventListener(event, onInteraction, {
        once: true,
        passive: true,
      })
    );

    return () => {
      clearTimeout(timer);
      events.forEach((event) =>
        window.removeEventListener(event, onInteraction)
      );
    };
  }, []);
};
